var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDistribute = function SvgDistribute(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44 44"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "distribute_svg__a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceGraphic",
    values: "0 0 0 0 0.101961 0 0 0 0 0.090196 0 0 0 0 0.231373 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    filter: "url(#distribute_svg__a)",
    transform: "translate(0 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4h44v44H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.375 5.375h41.25v41.25H1.375z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M20.167 46.625c5.197 0 9.902-2.103 13.305-5.503l-13.305-13.24V9.145c-10.377 0-18.792 8.387-18.792 18.737 0 10.349 8.415 18.743 18.792 18.743zm2.59-21.443h19.868c0-10.94-8.898-19.807-19.868-19.807v19.807zm1.055 2.63L37.17 40.997a18.634 18.634 0 0 0 5.446-13.185H23.812z"
  }))));
};
export default SvgDistribute;